import { Component, OnInit } from "@angular/core"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-profitloss",
	templateUrl: "./profitloss.component.html",
})
export class ProfitlossComponent extends Modalable {
	modalTitleLang: string = "profitloss_report"
	modalWidth: string = "modal-full-width"

	monthNames: string[] = [
		"jan",
		"feb",
		"mar",
		"apr",
		"may",
		"jun",
		"jul",
		"aug",
		"sep",
		"oct",
		"nov",
		"dec",
	] //month names to be used as columns/fields if the data and display
	years: any[] = [] //the options for years to choose from
	showByCreatedAt: any = "no"
	data: any = null //will hold the data returning from the api call
	expensetypeNames: string[] = [] //holds the names of all expensetypes in the data
	thisYear = new Date().getFullYear()
	lastYear = new Date().getFullYear() - 1
	year: number = this.thisYear

	totals: any = {}
	periodInputs: any[] = []

	vat_numbers: any[] = []
	is_new_vat_number: boolean = false
	vat_number: string = ""

	ngOnInit() {
		//when called to open call loadData from the api
		this.periodInputs = [
			{ value: this.thisYear, lang: this.lang.getVal("this_year") },
			{ value: this.lastYear, lang: this.lang.getVal("last_year") },
		]
		for (let i = 2018; i <= this.thisYear; i++) {
			this.years.push({ id: i, name: i })
		}
		this.loadData()

		const cliniqData = this.store.getCliniqDataOrExit()
		if (cliniqData.expenses_by_created_at_default == "yes") {
			this.showByCreatedAt = "yes"
		}
		if (cliniqData.is_new_vat_number == "yes") {
			this.is_new_vat_number = true
			this.vat_numbers = [
				{ id: "", name: this.lang.getVal("all_vat_numbers") },
				{ id: cliniqData.old_vat_number, name: cliniqData.old_vat_number },
				{ id: cliniqData.vat_number, name: cliniqData.vat_number },
			]
		}
		this.vat_number = ""
	}

	changeByPeriod(year: number) {
		//clicked the change period btn, change the year and loadData
		this.year = year
		this.loadData()
	}
	changeBtn(fieldName: string, value: string) {
		//change period = update display dates and get new data from api
		this.loadData()
	}

	async loadData() {
		//load new data from api
		// this.data=null;
		const res: any = await this.apiService.post(
			"get_profitloss_report",
			this,
			"year,showByCreatedAt,vat_number"
		)
		this.data = Object.values(res) //get only the values of the returned data (each is a month with its income and expenses)
		this.totals = {} //reset totals column
		this.expensetypeNames = [] //reset expense names

		this.totals.income = 0 //reset income, totalExpenses, profitloss for the totals column
		this.totals.totalExpenses = 0
		this.totals.profitloss = 0
		this.data.forEach((month) => {
			//iterate each month
			let monthTotalExpenses = 0 //reset total expenses for this month
			this.totals.income += month.income //add month income to totals income

			Object.keys(month)
				.filter((key) => key != "income")
				.forEach((expensetypeName) => {
					//iterate the expenses in the month (without income)

					monthTotalExpenses += Number(month[expensetypeName]) //add this expense's cost to this month's total

					if (!this.expensetypeNames.includes(expensetypeName)) {
						//if expensetypeNames doesn't have this expense - add it
						this.expensetypeNames.push(expensetypeName)
					}
					if (!this.totals[expensetypeName]) {
						//if totals column doesn't have a key for this expense - add it
						this.totals[expensetypeName] = 0
					}
					this.totals[expensetypeName] += Number(month[expensetypeName]) //add this expense's cost to the totals column for this expense
				})
			month.totalExpenses = this.store.numberFormat(monthTotalExpenses) //set month total to this month's expenses total
			this.totals.totalExpenses += Number(monthTotalExpenses) //add this month's expenses total to the total column's total
			let monthProfitloss = month.income - monthTotalExpenses //calculate profitloss for month (icnome-total expenses)
			month.profitloss = this.store.numberFormat(monthProfitloss) //save month's profitloss
			this.totals.profitloss += Number(monthProfitloss) //add month's profitloss to total column's profitloss
			this.expensetypeNames.sort() //sort alphabetically
		})
		Object.keys(this.totals).forEach((key) => {
			//for each key in the totals column (income, various expenses, total, profitloss) - format the number
			this.totals[key] = this.store.numberFormat(this.totals[key])
		})
	}
	async downloadReport() {
		//download the report for the chosn year (xlsx format)
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download("get_profitloss_report", {
				year: this.year,
				dlExcel: true,
			})
			this.apiService.downloadFile(res, "report.xlsx")
		})
	}

	async print() {
		//print this report by creating a new document, opening it, and requesting the winodw to print

		let html = document.getElementById("section-to-print").innerHTML //get the inner area to be replicated in the new document
		html = this.store.processHtmlPreDl(html) //remove noise in html tags (angular attributes etc)

		this.store.printWindow(`
		<html>
		<style type='text/css'>${this.store.getPrintStyle2()}</style>
		<body onload="window.print()" style="direction:rtl">
		${html}
		</body>
		</html>`)
	}
}
